<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { isAtMax, isAtMin, productQuantity } from '../store/pdp_store';

  const { productQtyUpdateEnabled, productDetails } = getAppConfig();
  const { minOrderQuantity, maxOrderQuantity, marketPlaceProduct, marketPlaceOfferData, isDigitalGiftCard, isRSAItem } =
    productDetails;
  const min = marketPlaceProduct ? marketPlaceOfferData?.minOrderQuantity : minOrderQuantity;

  const max = marketPlaceProduct ? marketPlaceOfferData?.maxOrderQuantity : maxOrderQuantity;
  export let containerClass: string = '';
  export let displayQtyModifier: boolean = false;
</script>

{#if productQtyUpdateEnabled && !isDigitalGiftCard && displayQtyModifier && !isRSAItem}
  <div class="qty-modifier-wrapper {containerClass}">
    <div class="pdp-quantity-modifier">
      <button
        disabled={$isAtMin}
        class="qty-modifier-btn"
        on:click={() => productQuantity.decrement()}
        aria-label="Decrease quantity"
      >
        <span class="c_icon_new c_icon_new--subtract"></span>
      </button>

      <input
        type="number"
        value={$productQuantity}
        on:keydown={e => e.key === 'Enter' && productQuantity.updateQuantity(e.currentTarget.value)}
        on:blur={e => {
          productQuantity.updateQuantity(e.currentTarget.value);
        }}
        aria-label="Product quantity"
        class="quantity-input"
        {min}
        {max}
      />

      <button
        disabled={$isAtMax}
        class="qty-modifier-btn"
        on:click={() => productQuantity.increment()}
        aria-label="Increase quantity"
      >
        <span class="c_icon_new c_icon_new--add"> </span>
      </button>
    </div>
  </div>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .qty-modifier-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
    &.sticky-bar {
      margin-right: 16px;
      margin-bottom: 0;
      .pdp-quantity-modifier {
        width: 104px;
        @include desktop-min-width {
          width: 110px;
        }
      }
    }
    .pdp-quantity-modifier {
      align-items: center;
      border: 1px solid $secondary-gray-02;
      border-radius: 8px;
      display: flex;
      padding: 4px 16px;
      width: 123px;
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      .quantity-input {
        border: 0;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        &:focus {
          border: 0;
          outline: 0;
        }
      }
      .qty-modifier-btn {
        background: none;
        border: 0;
        outline: none;
        padding: 0;
        span {
          color: #0065a4;
          font-size: 16px;
        }
      }
    }
  }
</style>
